import { useNavigate, useParams } from "react-router";
import {
  MilestonePage,
  MilestonePageContent,
  MilestonePageHeader,
  MilestonePageTitle,
} from "@/shared/bsm/core/milestone/components/ui/milestone-page";
import t from "@/lang/lang";
import { CreateWorkOrderButton } from "@/services/backend/rlt/work-orders/components/create-work-order-button";
import {
  WorkOrderTable,
  WorkOrderTableFilters,
} from "@/services/backend/rlt/work-orders/components/work-order-table";
import { useState } from "react";
import { ListRequest } from "@/services/backend/rlt/work-orders/api/work-order-api";
import { DocumentLink } from "@/routes/_components/links/document-link";
import { GSMServiceKind } from "@/services/backend/services/types/kinds";
import { useProcessesProcessShowQuery } from "@/services/backend/processes/api/process-api";
import {
  BreadcrumbItem,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/shared/components/ui/breadcrumb";
import { ProcessPageMainTemplate } from "@/routes/processes/[processId]/_components/process-page-main-template";
import { RltBreadcrumbs } from "@/routes/processes/[processId]/rlt/_components/rlt-breadcrumbs";

export function WorkOrderIndexRoute() {
  const { processId } = useParams();
  const navigate = useNavigate();
  const [request, setRequest] = useState<ListRequest>({
    process: {
      active: true,
      values: [processId!],
    },
    limit: 10,
    offset: 0,
  });

  const { data: process } = useProcessesProcessShowQuery({ id: processId! });

  if (!process) return null;

  const breadcrumbs = (
    <RltBreadcrumbs customerId={process.customerId} processId={process.id}>
      <BreadcrumbSeparator />
      <BreadcrumbItem>
        <BreadcrumbPage>{t("Arbeitsscheine")}</BreadcrumbPage>
      </BreadcrumbItem>
    </RltBreadcrumbs>
  );

  return (
    <ProcessPageMainTemplate breadcrumbs={breadcrumbs}>
      <MilestonePage>
        <MilestonePageHeader>
          <MilestonePageTitle className="border-none pb-0">
            {t("Arbeitsscheine")}
          </MilestonePageTitle>
        </MilestonePageHeader>
        <MilestonePageContent>
          <div className="grid gap-2">
            <div className="flex justify-between">
              <WorkOrderTableFilters
                request={request}
                onRequestChange={setRequest}
              />
              <CreateWorkOrderButton
                processId={processId!}
                onCreated={(id) => navigate(id)}
              />
            </div>
            <WorkOrderTable
              request={request}
              onRequestChange={setRequest}
              renderRowLink={(id, pid, kind) => (
                <DocumentLink
                  documentId={id}
                  documentKind={kind}
                  serviceKind={GSMServiceKind.RLT}
                  processId={pid}
                />
              )}
            />
          </div>
        </MilestonePageContent>
      </MilestonePage>
    </ProcessPageMainTemplate>
  );
}
